var DynamicCertificateFormModule = /** @class */ (function () {
    function DynamicCertificateFormModule() {
    }
    return DynamicCertificateFormModule;
}());
export { DynamicCertificateFormModule };
